/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Source_DescInputs */

const en_pc_dl_source_desc = /** @type {(inputs: Pc_Dl_Source_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Needs Rust 1.95 or newer. Run cargo xtask models first if you want Scan & OCR in your build.`)
};

const zh_pc_dl_source_desc = /** @type {(inputs: Pc_Dl_Source_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要 Rust 1.95 或更高版本。如果希望构建中包含 Scan & OCR，请先运行 cargo xtask models。`)
};

/**
* | output |
* | --- |
* | "Needs Rust 1.95 or newer. Run cargo xtask models first if you want Scan & OCR in your build." |
*
* @param {Pc_Dl_Source_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_source_desc = /** @type {((inputs?: Pc_Dl_Source_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Source_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_source_desc(inputs)
	return zh_pc_dl_source_desc(inputs)
});
export { pc_dl_source_desc as "pc.dl.source_desc" }